import React from 'react';
import { Image } from '@chakra-ui/react';
import siesa1 from '../../img/siesa1.webp';
import logo2 from '../../img/logo2.png';
import logoSimple from '../../img/logoSimple.png';

/**
 * Componente centralizado para la identidad de marca de SIESA.
 * - variant="navbar": Usa siesa1.png (logo principal destacado para el header)
 * - variant="footer": Usa logo2.png (para el pie de página)
 * - Por defecto: Usa logoSimple.png
 */
export default function SiesaLogo({
  variant = 'darkOnLight',
  src,
  alt = 'SIESA',
  w,
  h,
  maxH,
  ...props
}) {
  let logoSrc = src;
  if (!logoSrc) {
    if (variant === 'navbar') {
      logoSrc = siesa1;
    } else if (variant === 'footer') {
      logoSrc = logo2;
    } else {
      logoSrc = logoSimple;
    }
  }

  return (
    <Image
      src={logoSrc}
      alt={alt}
      w={w || 'auto'}
      h={h || 'auto'}
      maxH={maxH}
      objectFit="contain"
      {...props}
    />
  );
}
